import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useTheme, styled } from '@mui/material/styles';
import { Box, Card, CardHeader, CircularProgress, Typography } from '@mui/material';
// import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';
import { useSelector } from 'react-redux';
import { useUtilidades } from '../../../contexts/UtilidadesContext';
import { useEffect, useState } from 'react';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 392;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

export default function CardTorta({ data, enviosLicenciatario = [], isAdmin }) {
  const [loading, setLoading] = useState(true);
  const { getUtilidadesPorServicio } = useUtilidades();
  const utilidadesPorServicio = getUtilidadesPorServicio(isAdmin);
  const theme = useTheme();

  const { envios: enviosFromState } = useSelector((state) => state.dagpacket);
  const envios = isAdmin ? enviosFromState : enviosLicenciatario;

  const formatToTwoDecimalPlaces = (num) => parseFloat(num).toFixed(2);
  const labels2 = Object.keys(utilidadesPorServicio);
  const chartData2 = Object.values(utilidadesPorServicio).map((valueArray) => (valueArray?.length ? valueArray[0] : 0));

  function fNumber(number, decimalPlaces = 2) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }).format(number);
  }

  const chartData = chartData2.map((value) => (value === undefined ? 0 : parseFloat(formatToTwoDecimalPlaces(value))));

  const chartOptions = merge(BaseOptionChart(), {
    colors: ['#946c00', '#00941b', '#eb6d06', '#00b894', '#ff6b81', '#980000', '#070094', '#9370db', '#ffcd56'],
    labels: labels2,
    stroke: { colors: [theme.palette.background.paper] },
    legend: { floating: true, horizontalAlign: 'center' },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (seriesName) => fNumber(formatToTwoDecimalPlaces(seriesName)),
        title: {
          formatter: (seriesName) => `${seriesName}`
        }
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '90%',
          labels: {
            value: {
              formatter: (val) => `$${fNumber(formatToTwoDecimalPlaces(val))}`
            },
            total: {
              formatter: (w) => {
                const sum = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                return `$${fNumber(formatToTwoDecimalPlaces(sum))}`;
              }
            }
          }
        }
      }
    }
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const RenderContent = () => {
    if (loading) {
      return <CircularProgress />;
    }
    return (
      <Card>
        <CardHeader title="Utilidad por servicio en esta quincena" />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {envios.length === 0 ? (
            <Typography variant="h6" align="center" sx={{ mt: 5 }}>
              No hay datos por el momento
            </Typography>
          ) : (
            <>
              <ChartWrapperStyle dir="ltr">
                <ReactApexChart type="donut" series={chartData} options={chartOptions} height={280} />
              </ChartWrapperStyle>
            </>
          )}
        </Box>
      </Card>
    );
  };

  return (
    <>
      <RenderContent />
    </>
  );
}
